import styled, { css } from 'styled-components';
import { s as sentimentScaleOptionLabelEmojiTheme } from './sentimentScaleOptionLabelEmojiTheme-C7XWHqID.js';

let Variant = /*#__PURE__*/function (Variant) {
  Variant["VERY_DISSATISFIED"] = "veryDissatisfied";
  Variant["DISSATISFIED"] = "dissatisfied";
  Variant["NEITHER_SATISFIED_NOR_DISSATISFIED"] = "neitherSatisfiedNorDissatisfied";
  Variant["SATISFIED"] = "satisfied";
  Variant["VERY_SATISFIED"] = "verySatisfied";
  return Variant;
}({});
const getPath = ({
  $checked,
  $disabled,
  $hovered
}) => {
  switch (true) {
    case $disabled:
      {
        return css(["fill:", ";"], ({
          theme
        }) => theme.sentimentScaleOptionLabelEmoji.pathDisabled);
      }
    case $hovered:
      {
        return css(["fill:", ";"], ({
          theme
        }) => theme.sentimentScaleOptionLabelEmoji.pathHovered);
      }
    case $checked:
      {
        return css(["fill:", ";"], ({
          theme
        }) => theme.sentimentScaleOptionLabelEmoji.pathChecked);
      }
    default:
      {
        return css(["fill:", ";"], ({
          theme
        }) => theme.sentimentScaleOptionLabelEmoji.path);
      }
  }
};
const getHoveredPath = ({
  $checked,
  $disabled
}) => getPath({
  $checked,
  $disabled,
  $hovered: true
});
const getCircle = ({
  $checked,
  $variant
}) => {
  switch (true) {
    case $checked:
      {
        return css(["fill:", ";"], ({
          theme
        }) => theme.sentimentScaleOptionLabelEmoji.backgroundChecked[$variant]);
      }
    default:
      {
        return css(["fill:", ";"], ({
          theme
        }) => theme.sentimentScaleOptionLabelEmoji.background);
      }
  }
};
const StyledSvg = /*#__PURE__*/styled('svg').attrs(({
  theme
}) => ({
  theme: {
    ...theme,
    sentimentScaleOptionLabelEmoji: sentimentScaleOptionLabelEmojiTheme
  }
})).withConfig({
  componentId: "sc-storm-ui-30062554__sc-1urlqpc-0"
})(["display:block;&& > path{", "}&&:hover > path{", "}&& > circle{", "}"], getPath, getHoveredPath, getCircle);

export { StyledSvg as S, Variant as V };
//# sourceMappingURL=StyledSvg-Bc-aUfmk.js.map
